import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconHeartStyle0 = cosmosIconCss;

const CosmosIconHeart$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHeart extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '98d4ec3be907403bca4144c93d3cd852b3041766', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5633bbaf62799ae3cf3fa0a589b08803fe581ad1', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8dcc2d33b2a6b5ea4298ea34ff13d2638384bdc7', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11 16.06 5.66-5.87a3.035 3.035 0 0 0 .85-2.1 2.537 2.537 0 0 0-2.48-2.59 2.4 2.4 0 0 0-1.75.76l-1.92 1.96a.485.485 0 0 1-.72 0L8.72 6.26a2.4 2.4 0 0 0-1.75-.76 2.537 2.537 0 0 0-2.48 2.59 3.08 3.08 0 0 0 .85 2.1L11 16.06Zm-.34 1.8-6.4-6.63A4.569 4.569 0 0 1 3 8.08 4.011 4.011 0 0 1 6.97 4 3.925 3.925 0 0 1 9.8 5.22L11 6.44l1.2-1.22A3.925 3.925 0 0 1 15.03 4 4.011 4.011 0 0 1 19 8.08a4.506 4.506 0 0 1-1.26 3.15l-6.4 6.63A.444.444 0 0 1 11 18a.444.444 0 0 1-.34-.14Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconHeartStyle0; }
}, [1, "cosmos-icon-heart", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-heart"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-heart":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHeart$1);
            }
            break;
    } });
}

const CosmosIconHeart = CosmosIconHeart$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHeart, defineCustomElement };
